import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import useStyles from './summaryContentStyle'
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined'
import { v4 as uuidv4 } from 'uuid'

const SummaryContent = (props) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const id = uuidv4()

  return (
    <>
      <div className={classes.summaryBody} style={props.style}>
        <div className={classes.infoGenIa}>
          {t('summary.aiGeneratedResponse')}
          <div className={classes.infoGenIaIcon}>
          <BoltOutlinedIcon></BoltOutlinedIcon>
          </div>
        </div>

        <div className={classes.summaryText}>{props?.summaryText}</div>

        <div className={classes.keywordsTitle}>{t('summary.keywords')} :</div>

        <div className={classes.keywords}>
          {props?.keywords?.map((keyword, index) => (
            <div className={classes.keyword} key={`${keyword}${index}${id}`}>
              <span className={classes.keywordText}>{keyword}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default memo(SummaryContent)
